import {
  Box,
  Container,
  Divider,
  Link,
  Stack,
  SvgIcon,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import ArrowLeftIcon from '@untitled-ui/icons-react/build/esm/ArrowLeft';
import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router';
import { RouterLink } from 'src/components/router-link';
import { paths } from 'src/paths';
import { useDispatch, useSelector } from 'react-redux';
import MdsAssessmentUploadTable from './mds-upload-table';
import { getValidationCSVTemplateOfMdsReset } from 'src/redux/actions/therapyPlanning';
import SimpleSnackbar from 'src/pages/details-page/sub-components/snackBar';

const { patients } = paths;
function MdsAssessmentUpload() {
  const [activeTab, setActiveTab] = useState('validRecords');
  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setActiveTab(newValue);
  };

  const validateCsvResponseOfMds = useSelector((state: any) => state.validateMDSAssessmentCsv);

  const [patientError, setPatientError] = useState({
    message: '',
    isError: false,
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { patients } = paths;
  useEffect(() => {
    if (!validateCsvResponseOfMds.isError && validateCsvResponseOfMds.response === null) return;
    if (validateCsvResponseOfMds.isError && validateCsvResponseOfMds.errorMessage !== null) {
      setPatientError({
        message: validateCsvResponseOfMds?.errorMessage?.message
          ? validateCsvResponseOfMds?.errorMessage?.message
          : 'Please Add Valid File',
        isError: true,
      });
      setTimeout(() => {
        dispatch(getValidationCSVTemplateOfMdsReset());
      }, 5000);
      return;
    }

    return;
  }, [validateCsvResponseOfMds]);

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 5,
      }}
    >
      <Container maxWidth={'xl'}>
        <Stack spacing={4}>
          <Stack spacing={4}>
            <div>
              <Link
                color="text.primary"
                component={RouterLink}
                // href={paths.patients}
                onClick={handleBack}
                sx={{
                  alignItems: 'center',
                  display: 'inline-flex',
                }}
                underline="hover"
              >
                <SvgIcon sx={{ mr: 1 }}>
                  <ArrowLeftIcon />
                </SvgIcon>
                <Typography variant="subtitle2">Back to mds Assessment</Typography>
              </Link>
            </div>
            <Stack
              alignItems="flex-start"
              direction={{
                xs: 'column',
                md: 'row',
              }}
              justifyContent="space-between"
              spacing={4}
            >
              <Stack spacing={1}>
                <Typography variant="h4">Upload MDS Assessment</Typography>
              </Stack>
            </Stack>
          </Stack>
          <div>
            <Tabs
              indicatorColor="primary"
              scrollButtons="auto"
              sx={{ mt: 3 }}
              textColor="primary"
              variant="scrollable"
              value={activeTab}
              onChange={handleTabChange}
            >
              <Tab
                key="validRecords"
                label={`Valid Records (${
                  validateCsvResponseOfMds?.response?.data?.patientMdsSuccessResponseList?.length ||
                  0
                })`}
                value="validRecords"
              />
              <Tab
                key="invalidRecords"
                label={`InValid Records (${
                  validateCsvResponseOfMds?.response?.data?.patientFailureResponses?.length || 0
                })`}
                value="invalidRecords"
              />
            </Tabs>
            <Divider />
          </div>
          <Outlet />
          <MdsAssessmentUploadTable
            source={activeTab}
            items={
              activeTab === 'validRecords'
                ? validateCsvResponseOfMds?.response?.data?.patientMdsSuccessResponseList
                : validateCsvResponseOfMds?.response?.data?.patientFailureResponses
            }
            validateCSVResponse={validateCsvResponseOfMds?.response?.data}
          />
        </Stack>
      </Container>

      {validateCsvResponseOfMds?.errorMessage && (
        <SimpleSnackbar
          isError={patientError.isError}
          message={patientError.message}
        />
      )}
    </Box>
  );
}

export default MdsAssessmentUpload;
